/**
 * @generated SignedSource<<a52058f963e06e231dc45b0d8ad4dc2b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Locale = "EN" | "LT";
import { FragmentRefs } from "relay-runtime";
export type EditorToolbar_languages$data = ReadonlyArray<{
  readonly locale: Locale;
  readonly " $fragmentSpreads": FragmentRefs<"EditorLanguageButton_language" | "EditorTranslateButton_from" | "EditorTranslateButton_to">;
  readonly " $fragmentType": "EditorToolbar_languages";
}>;
export type EditorToolbar_languages$key = ReadonlyArray<{
  readonly " $data"?: EditorToolbar_languages$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditorToolbar_languages">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "EditorToolbar_languages",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locale",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditorLanguageButton_language"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditorTranslateButton_to"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditorTranslateButton_from"
    }
  ],
  "type": "Language",
  "abstractKey": null
};

(node as any).hash = "ee1c528c61a92769e083b419de708b99";

export default node;
